import { Component } from '@angular/core';
import { EventBusService, EventType } from '../services/eventbus.service';

@Component({
    selector: 'notification-flier',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
    NotificationStatus = NotificationStatus;
    notifications: NotificationItem[] = new Array<NotificationItem>();

    constructor(private eventBusService: EventBusService) {
        this.eventBusService.getEventBus(EventType.NOTIFY_FAILURE_EVENT)
            .subscribe(response => this.showNotification(new NotificationItem(response.getString(), NotificationStatus.ERROR), 10000));
        this.eventBusService.getEventBus(EventType.NOTIFY_SUCCESS_EVENT)
            .subscribe(response => this.showNotification(new NotificationItem(response.getString(), NotificationStatus.INFO), 10000));
        this.eventBusService.getEventBus(EventType.NOTIFY_SUCCESS_OFFLINE)
            .subscribe(response => this.showNotification(new NotificationItem(response.getString(), NotificationStatus.SUCCESS), 3000));
        this.eventBusService.getEventBus(EventType.NOTIFY_PENDING_OFFLINE)
            .subscribe(response => this.showNotification(new NotificationItem(response.getString(), NotificationStatus.PENDING), 0));
        this.eventBusService.getEventBus(EventType.NOTIFY_FAILURE_OFFLINE)
            .subscribe(response => this.showNotification(new NotificationItem(response.getString(), NotificationStatus.FAILURE), 10000));
    }

    dismiss(notificationItem: NotificationItem): void {
        let index: number = this.notifications.indexOf(notificationItem);
        if (index > -1) {
            this.notifications.splice(index, 1);
        }
    }

    private showNotification(notificationItem: NotificationItem, time: number): void {
        if ((notificationItem.status === NotificationStatus.SUCCESS) || (notificationItem.status === NotificationStatus.FAILURE)) {
           this.notifications.map((notify, index) => {
            if (notify.status ===  NotificationStatus.PENDING) {
                this.notifications.splice( index, 1);
            }
           })
        }
        this.notifications.push(notificationItem);
        if (notificationItem.status !== NotificationStatus.PENDING) {
            setTimeout(() => this.dismiss(notificationItem), time);
        }
    }
}

export class NotificationItem {
    constructor(public message: string, public status: NotificationStatus) { };
}

export enum NotificationStatus {
    ERROR,
    WARNING,
    INFO,
    SUCCESS,
    PENDING,
    FAILURE
}
